export * from "../../../Models/Rental/RiderDetails/ProductAndRiderDetails";
export * from "../../../Models/Rental/RiderDetails/RiderData";

export namespace Models {
    export class RiderDetailsModelBundle {}
}